export const themes = {
  night:  { id: 'night',  name: 'Nuit',   background: '#1a1a2e', color: '#e8e0f0', accentColor: '#9FE1CB', ornament: '❧' },
  violet: { id: 'violet', name: 'Violet', background: '#3C3489', color: '#EEEDFE', accentColor: '#CECBF6', ornament: '✦' },
  forest: { id: 'forest', name: 'Forêt',  background: '#085041', color: '#E1F5EE', accentColor: '#9FE1CB', ornament: '✿' },
  coral:  { id: 'coral',  name: 'Corail', background: '#712B13', color: '#FAECE7', accentColor: '#F5C4B3', ornament: '❦' },
  ocean:  { id: 'ocean',  name: 'Océan',  background: '#0C447C', color: '#E6F1FB', accentColor: '#B5D4F4', ornament: '❋' },
  ivory:  { id: 'ivory',  name: 'Ivoire', background: '#f7f3ee', color: '#2C2C2A', accentColor: '#8b6c3a', ornament: '❧' },
  rose:   { id: 'rose',   name: 'Rose',   background: '#72243E', color: '#FBEAF0', accentColor: '#F4C0D1', ornament: '❀' },
  amber:  { id: 'amber',  name: 'Ambre',  background: '#633806', color: '#FAEEDA', accentColor: '#FAC775', ornament: '✾' },
};

export const defaultTheme = themes.night;
export const themeList = Object.values(themes);
